import React, { Component } from 'react';
import { FormattedText, formatText } from 'core/i18n';
import { isMobile } from 'utilities/browser';
import { Header } from 'components/header/header';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { errorTag } from 'utilities/uTagging';
import { PATH_JOINHOLDER_ERROR } from 'constants/uTagConstants/paths';
import { PUBLICA_URL, LOGIN_DESKTOP, LOGIN_MOBILE } from 'constants/index';

class JointJolderErrorView extends Component {
    constructor(props) {
        super(props);

        this.onHandleAction = this.onHandleAction.bind(this);
    }

    componentDidMount() {
        errorTag('', PATH_JOINHOLDER_ERROR);
    }

    onHandleAction() {
        const mobileLoginToggleString = isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP;

        window.location.href = PUBLICA_URL + mobileLoginToggleString;
    }

    render() {
        const mobileLoginToggleString = isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP;

        return (
            <div className="basic-layering">
                <Header title={formatText('messagesScreen-becomeCustomer')} />
                <div className="main-container messages-main-container">
                    <div className="profesional-data-view">
                        <MessagesScreen
                            iconClass="icons icons--icon-warning"
                            title={formatText('messagesScreen-jointHolderErrorTitle')}
                            subtitle={formatText('messagesScreen-jointHolderErrorSubtitle')}
                            buttonText={formatText('button-understood')}
                            buttonClass="form__button form__button-secondary"
                            action={this.onHandleAction}
                        >
                            <FormattedText
                                value="messagesScreen-jointHolderErrorContent"
                                injectedStrings={[PUBLICA_URL + mobileLoginToggleString]}
                            />
                        </MessagesScreen>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = JointJolderErrorView;
